import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {Device} from "../../../shared/interface/device";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LicenseService} from "../../../shared/services/license.service";
import {takeUntil} from "rxjs/operators";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {HttpErrorResponse} from "@angular/common/http";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {
  FILE_TYPE_HANDOVER_PROTOCOL,
  FILE_TYPE_RETURN_PROTOCOL
} from "../../../shared/services/dict.service";
import {FormBuilder, FormControl} from "@angular/forms";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {Document} from "../../../shared/interface/document";
import {DocumentAddDialogComponent} from "../../documents/document-add-dialog/document-add-dialog.component";
import {MatDialog} from "@angular/material/dialog";
@Component({
  selector: 'app-device-details',
  templateUrl: './device-details.component.html',
  styleUrls: ['./device-details.component.scss']
})
export class DeviceDetailsComponent implements OnInit, OnDestroy {

  readonly DOCUMENTS_TYPES = [FILE_TYPE_HANDOVER_PROTOCOL,
    FILE_TYPE_RETURN_PROTOCOL
  ];

  uuid?: string = null;
  deviceId?: string = null;
  deviceObject?: Device;
  device: ReplaySubject<Device> = new ReplaySubject<Device>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  typeControl: FormControl;
  documents: ReplaySubject<Document[]> = new ReplaySubject<Document[]>(1);

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private route: ActivatedRoute,
    private licenseService: LicenseService,
    private snack: MatSnackBar,
    private auth: AuthService,
    private dialog: MatDialog,
    private fb: FormBuilder,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.uuid = params.id;
        this.loadDevice();
        this.loadDocuments();
      });
    this.typeControl = this.fb.control('');

    this.typeControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        if (!dictId) {
          this.loadDocuments();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
  }

  loadDevice(): void {
    this.licenseService.getDevice(this.uuid).subscribe((device: Device) => {
      this.device.next(device);
      this.deviceObject = device;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych urządzenia', error.status.toString(), {
        duration: 2000
      });
    });
  }

  loadDocuments(id?: number): void {
    this.licenseService.getDeviceDocuments(this.uuid, id)
      .subscribe((documents: ListResponse<Document>) => {
        this.documents.next(documents.items);
      });
  }

  addDocument(): void {
    const dialogRef = this.dialog.open(DocumentAddDialogComponent, {
      width: '55%',
      data: {
        deviceObject: this.deviceObject,
        types: [
          FILE_TYPE_HANDOVER_PROTOCOL,
          FILE_TYPE_RETURN_PROTOCOL,
        ],
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.loadDocuments();
    });
  }

}
